import React, { useEffect } from "react";
import { Select, SelectOption, Nullable } from "@gemlightbox/core-kit";

import { useStores } from "src/hooks";

interface ProductSubTypeSelectProps {
  disabled: boolean;
  mainSelectedOption: SelectOption<string> | undefined;
  selectedOption: SelectOption<string> | undefined;
  onChange: (value: SelectOption<string> | undefined) => void;
}

export const ProductSubTypeSelect: React.FC<ProductSubTypeSelectProps> = ({
  disabled,
  mainSelectedOption,
  selectedOption,
  onChange,
}) => {
  const { localeStore, categoriesStore } = useStores();

  const options: SelectOption<string>[] =
    categoriesStore?.categoriesV2
      ?.filter((item) => item.mainTypeKey === mainSelectedOption?.value)
      ?.map((item) => ({
        label: item.label,
        value: item.key,
        name: item.name,
        indelible: true,
      })) || [];

  const handleChange = (option: Nullable<SelectOption<string>> | undefined) => {
    if (option === undefined) return;

    if (option === null) {
      onChange(undefined);
    }

    if (option !== null) {
      const { value, label } = option;
      if (!value || !label) return;
      onChange({ label, value });
    }
  };

  const optionsLength = options.length;

  useEffect(() => {
    const shouldResetSelection = !mainSelectedOption || optionsLength === 0;

    if (shouldResetSelection && selectedOption) {
      onChange(undefined);
    }
  }, [mainSelectedOption, onChange, optionsLength, selectedOption]);

  return (
    <Select
      appearance="primaryV2"
      label={localeStore.t('["product-attributes"]["sub-type"]')}
      placeholder={
        disabled
          ? ""
          : localeStore.t('["product-attributes"]["attribute-field"]["select-placeholder"]')
      }
      selectedOptionsKeys={selectedOption}
      options={options}
      onChange={handleChange}
      canCreate={false}
      isTextEditable
      disableError
      disabled={disabled}
      data-hj-allow
    />
  );
};
